<article class="group cursor-pointer">
  <a [routerLink]="articlePath()" class="block">
    <div class="relative mb-5 aspect-[5/4] overflow-hidden rounded-[2.5rem] shadow-sm">
      @if (post().category) {
        <span
          class="absolute left-4 top-4 z-10 inline-flex rounded-full bg-[color-mix(in_srgb,var(--color-primary)_12%,white)] px-[14px] py-[6px] text-[10px] leading-none font-bold tracking-[0.18em] text-[var(--color-primary)] uppercase"
        >
          {{ post().category }}
        </span>
      }
      <img
        [src]="post().imageUrl"
        [alt]="post().title"
        loading="lazy"
        class="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
      />
      @if (post().storeLogoUrl) {
        <span
          class="absolute right-4 bottom-4 h-14 w-14 overflow-hidden rounded-full bg-white shadow-lg ring-1 ring-black/5"
        >
          <img
            [src]="post().storeLogoUrl"
            alt="Store logo"
            loading="lazy"
            class="h-full w-full rounded-full object-cover"
          />
        </span>
      }
    </div>
  </a>

  <div class="mb-3 flex items-center gap-3 text-[10px] font-black tracking-widest uppercase">
    @if (post().readTime) {
      <span class="text-slate-400">{{ post().readTime }}</span>
    }
    @if (post().readTime && post().author) {
      <span class="h-1 w-1 rounded-full bg-slate-300"></span>
    }
    @if (post().author) {
      @if (post().authorPath) {
        <a
          class="text-slate-500 transition-colors hover:text-[var(--color-primary-deep)]"
          [routerLink]="post().authorPath"
          >{{ post().author }}</a
        >
      } @else {
        <span class="text-slate-500">{{ post().author }}</span>
      }
    }
  </div>

  <h3 class="mb-3 transition-colors group-hover:text-[var(--color-primary)]">
    <a [routerLink]="articlePath()">{{ displayTitle() }}</a>
  </h3>

  @if (post().excerpt) {
    <p class="text-[14px] leading-[1.6] font-medium text-slate-500">{{ post().excerpt }}</p>
  }
</article>
